import React,{useState} from 'react';
import './SideNavbar.css'
import CloseIcon from '@mui/icons-material/Close';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
const SideNavbar = () => {
  
  return (
  <>
   
      <div className='side-navbar '>
      {/* <div className="close-btn" onClick={()=>setShow(prop.state)}><CloseIcon/></div> */}
      <div className="nav-items">
        <div className="nav-item">Home</div>
        <div className="nav-item">Services</div>
        <div className="nav-item">About Us</div>
        <div className="nav-item">Products</div>
        <div className="nav-item">Contact Us</div>
      </div>
      <hr />
      <div className="social-links">
        <div className="social-link"><FacebookIcon/></div>
        <div className="social-link"><XIcon/></div>
        <div className="social-link"><InstagramIcon/></div>
        <div className="social-link"><LinkedInIcon/></div>
      </div>
    </div>
    </>
  )
}

export default SideNavbar
